<h1 class="mine-title-m">{{ title }}</h1>

<p class="processing-activities-pdf__subtitle">
    <mine-spinner [width]="20" [height]="20" class="processing-activities-pdf__spinner"></mine-spinner>
    {{'ropa-pdf.generatingPdfReportSubtitle' | content}}
</p>